export enum MEETING_STATUS {
  REQUESTED,
  APPROVED,
  REJECTED,
  CANCELLED,
}

export const meetingStatusLabels = {
  [MEETING_STATUS.REQUESTED]: 'Requested',
  [MEETING_STATUS.APPROVED]: 'Approved',
  [MEETING_STATUS.REJECTED]: 'Rejected',
  [MEETING_STATUS.CANCELLED]: 'Cancelled',
};

export const meetingStatusColors = {
  [MEETING_STATUS.REQUESTED]: '#FFE600',
  [MEETING_STATUS.APPROVED]: '#00FF2A',
  [MEETING_STATUS.REJECTED]: '#FF2222',
  [MEETING_STATUS.CANCELLED]: '#FF009D',
};
